import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-avoided-emissions',
    imports: [TranslateModule],
    templateUrl: './avoided-emissions.component.html',
    styleUrl: './avoided-emissions.component.scss'
})
export class AvoidedEmissionsComponent {

}
